import readXlsxFile from 'read-excel-file';
export class MatrixChecker {
    constructor(document) {
        /** Roxs read from the matrix */
        this._rows = [];
        /** Errors found in the matrix */
        this.foundErrors = [];
        this._excelDocument = document;
        this.foundErrors = [];
    }
    /**
     * Read the given xlsx file and check values written in it
     * @returns an array of strings containing every errors found
     */
    async readExceldocumentAsync(sectors) {
        this._rows = await readXlsxFile(this._excelDocument);
        this._checkColumnsTitles();
        this._checkSectors(sectors.map(s => s.name));
        return this.foundErrors;
    }
    /**
     * Check if the columns are correctly named
     */
    _checkColumnsTitles() {
        for (let i = 0; i < MatrixChecker.columnsTitle.length; i++) {
            if (this._rows[0][i] !== MatrixChecker.columnsTitle[i]) {
                this.foundErrors.push(`L'entête de la colonne ${this._columnNameConverter(i)} doit être ${MatrixChecker.columnsTitle[i]}.`);
            }
        }
    }
    // /**
    //  * Check if the value in the first coumn is the same for each row 
    //  */
    // private _checkFirstColumn() {
    //     let matrixOpCode = this._rows[2][0];
    //     for (let i = 2; i < this._rows.length; i++) {
    //         if (!this._rows[i][0] || this._rows[i][0] !== matrixOpCode) {
    //             this.foundErrors.push(`La valeur de la case A${i+1} a un code opération différent du premier produit.`);
    //         }
    //     }
    // }
    // /**
    //  * Check if start and end dates are given for each row
    //  * Check if start date < end date 
    //  */
    // private _checkDate() {
    //     for (let i = 2; i < this._rows.length; i++) {
    //         if (!this._rows[i][2]) {
    //             this.foundErrors.push(`La valeur de la case C${i+1} est vide.`);
    //         }
    //         if (!this._rows[i][3]) {
    //             this.foundErrors.push(`La valeur de la case D${i+1} est vide.`);
    //         }
    //         if (this._rows[i][2] && this._rows[i][3]) {
    //             const startDate = new Date(this._rows[i][2]);
    //             const endDate = new Date(this._rows[i][3]);
    //             if (startDate > endDate) {
    //                 this.foundErrors.push(`La date de départ de la ligne ${i+1} est supérieure à la date de fin.`);
    //             }
    //         }
    //     }
    // }
    /**
     * Check if column "Categorie enfant" is correctly filled
     */
    _checkSectors(sectors) {
        for (let i = 1; i < this._rows.length; i++) {
            if (!this._rows[i][0]) {
                this.foundErrors.push(`La valeur de la case A${i + 1} est vide.`);
            }
            else if (!sectors.includes(this._rows[i][0])) {
                this.foundErrors.push(`La valeur de la case A${i + 1} est incorrecte. Elle doit être sélectionnée depuis la liste déroulante inclue dans le fichier excel.`);
            }
        }
    }
    // /**
    //  * Check each mea case
    //  * an mea must be undefined, 'x' or 'X'
    //  * execption for MDD : must be undefined or in the definedMea list
    //  */
    // private _checkMEA() {
    //     let checkValue = ['x', 'X'];
    //     for (let i = 2; i < this._rows.length; i++) {
    //         const meaFirstCouv = this._rows[i][9]?.trim();
    //         const meaDercouv = this._rows[i][10]?.trim();
    //         const meaBio = this._rows[i][11]?.trim();
    //         const meaMDD = this._rows[i][12]?.trim();
    //         const meaVedette = this._rows[i][13]?.trim();
    //         const meaStar = this._rows[i][14]?.trim();
    //         const meaGamme = this._rows[i][15]?.trim();
    //         if (meaFirstCouv && !checkValue.includes(meaFirstCouv)) {
    //             this.foundErrors.push(`La valeur de la case J${i+1} est incorrecte. Elle doit être 'x' ou 'X'.`);
    //         }
    //         if (meaDercouv && !checkValue.includes(meaDercouv)) {
    //             this.foundErrors.push(`La valeur de la case K${i+1} est incorrecte. Elle doit être 'x' ou 'X'.`);
    //         }
    //         if (meaBio && !checkValue.includes(meaBio)) {
    //             this.foundErrors.push(`La valeur de la case L${i+1} est incorrecte. Elle doit être 'x' ou 'X'.`);
    //         }
    //         if (meaMDD && !MatrixChecker.definedMea.includes(meaMDD)) {
    //             this.foundErrors.push(`La valeur de la case M${i+1} est incorrecte. Elle doit être sélectionnée dans la liste déroulante inclue dans le fichier excel.`);
    //         }
    //         if (meaVedette && !checkValue.includes(meaVedette)) {
    //             this.foundErrors.push(`La valeur de la case N${i+1} est incorrecte. Elle doit être 'x' ou 'X'.`);
    //         }
    //         if (meaStar && !checkValue.includes(meaStar)) {
    //             this.foundErrors.push(`La valeur de la case O${i+1} est incorrecte. Elle doit être 'x' ou 'X'.`);
    //         }
    //         if (meaGamme && !checkValue.includes(meaGamme)) {
    //             this.foundErrors.push(`La valeur de la case P${i+1} est incorrecte. Elle doit être 'x' ou 'X'.`);
    //         }
    //     }
    // }
    // /**
    //  * Check "meca Promo" column
    //  * must e undefined or in the "mecaPromo" list
    //  */
    // private _checkMecaPromo() {
    //     for (let i = 2; i < this._rows.length; i++) {
    //         if (this._rows[i][24] && !MatrixChecker.mecaPromo.includes(this._rows[i][24])) {
    //             this.foundErrors.push(`La valeur de la case Y${i+1} est incorrecte. Elle doit être sélectionnée dans la liste déroulante inclue dans le fichier excel.`);
    //         }
    //     }
    // }
    // /**
    //  * check % and Euro column
    //  * We cant fill both in the same row
    //  */
    // private _checkPercentEuro() {
    //     for (let i = 2; i < this._rows.length; i++) {
    //         if (this._rows[i][20] && this._rows[i][21]) {
    //             this.foundErrors.push(`Les cases U${i+1} et V${i+1} sont les deux remplies. Seulement une des 2 peut être renseignée.`);
    //         }
    //     }
    // }
    /**
     * Convert number to excel column name
     * ex : 0 gives A
     *      25 gives Z
     *      26 gives AA
     * @param num number to convert
     * @returns excel column name
     */
    _columnNameConverter(num) {
        let letters = '';
        while (num >= 0) {
            letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[num % 26] + letters;
            num = Math.floor(num / 26) - 1;
        }
        return letters;
    }
}
/**
 * Columns names in the matrix
 */
MatrixChecker.columnsTitle = [
    "Catégorie Enfant",
    "Titre",
    "Description",
    "Marque",
    "Prix",
];
